module.exports = __webpack_public_path__ + "__static/site-1768578553954/media/chicken-sound.93ab6ed7.mp4";